import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'react-bootstrap';
import { FaHistory, FaMapMarkerAlt, FaCheckCircle } from 'react-icons/fa';

export default function AboutUs() {
  return (
    <div
      className="p-4 text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '100vh',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="bg-dark bg-opacity-75 p-4 rounded">
        <h2 className="mb-4 text-white">About Us</h2>

        <Accordion defaultActiveKey="0">
          <AccordionItem eventKey="0">
            <AccordionHeader>
              <FaHistory className="me-2 text-primary" /> Our Story
            </AccordionHeader>
            <AccordionBody>
              <p>
                <strong>Jazuz Moving Company</strong> is a customer-centered North American moving brand founded in 2023 by Solomon Akintade, with a clear mission: to make moving smarter, smoother, and more meaningful.
              </p>
              <p>
                The vision for Jazuz was born when Solomon arrived in Canada in 2023 and began working with a local moving company. He recognized that while the moving industry had standard practices, there was still room to greatly improve the customer experience and crew welfare through more thoughtful models and efficient systems.
              </p>
              <p>
                Determined to bring this vision to life, Solomon returned to Nigeria and officially launched Jazuz Moving Company in Lagos. With just two movers and one truck, the company started humbly; but with a bold vision. Early days were tough. Unlike in North America, moving in Nigeria is often done informally, using friends or untrained workers, making it hard to attract clients willing to pay for professional service.
              </p>
              <p>
                Despite these challenges, Solomon leaned into his Canadian experience, implementing well-structured models, efficient scheduling, and a service-first approach, adapting them to fit the Nigerian context. Word began to spread, and over time, Jazuz became a name synonymous with reliability, professionalism, and peace of mind during moves.
              </p>
              <p>
                Fast forward to May 2025, Jazuz officially expanded to Canada, launching operations in Manitoba and Saskatchewan. The goal? To redefine what moving means; whether it’s across town or across countries by delivering a world-class experience that centers on trust, transparency, and teamwork.
              </p>
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="1">
            <AccordionHeader>
              <FaCheckCircle className="me-2 text-success" /> Why Jazuz?
            </AccordionHeader>
            <AccordionBody>
              <ul className="list-unstyled">
                <li className="mb-2">🛠 Structured service delivery inspired by North American standards</li>
                <li className="mb-2">📦 A seamless experience for both clients and crew</li>
                <li className="mb-2">🌍 Local roots, global vision—operating in both Nigeria and Canada</li>
              </ul>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
}
